import React from 'react';
import Scout from './Scout';

const LABEL = { orders: 'Orders', warehouse: 'Warehouse', dispatch: 'Dispatch', procurement: 'Procurement', stores: 'Stores', agents: 'Agents', portal: 'Supplier portal' };

// Orders/Warehouse/Dispatch/Procurement/Stores/Agents/Portal are present in
// the nav (matching the full demo) but not yet ported — this keeps them
// reachable and clearly labeled instead of rendering blank or erroring.
export default function ComingSoonView({ view }) {
  return (
    <div style={{ flex: 1, overflow: 'auto', padding: '32px 40px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'radial-gradient(1000px 480px at 50% -10%,#0C1638 0%,#050506 60%)' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, textAlign: 'center', maxWidth: 420 }}>
        <Scout agent="scout" style={{ width: 76, height: 78 }} />
        <div style={{ font: "400 28px/1.15 'Instrument Serif',serif" }}>{LABEL[view] || view} is next</div>
        <div style={{ fontSize: 13.5, lineHeight: 1.6, color: '#9C9CA6' }}>
          Overview, Inbox and Warehouse are live. {LABEL[view] || view} is still on the way — check back soon.
        </div>
      </div>
    </div>
  );
}
